export default __webpack_public_path__ + "static/media/i13.9c656264.jpeg";